<template>
  <div class="enterprise">
    <!--    <div class="gradient"></div>-->
    <!--    <div class="image">-->
    <!--      <img :src="bannerImage" style="width: 100%;height: 100%;" alt=""/>-->
    <!--    </div>-->
    <div class="hotClass">
      <div>
        <!-- 新课上线 -->
        <div class="index-content-box">
          <div class="index-course">
            <div class="index-content-tit">
              <h3>近期直播</h3>
            </div>
            <!--            <div style="border-top: 1px solid #DDDDDD"></div>-->
            <div class="jiantou-box">
              <img class="left" src="@/assets/images/jiantou.png" alt="" @click="prevSlide">
              <img class="right" src="@/assets/images/jiantou.png" alt="" @click="nextSlide">
            </div>
            <el-carousel arrow="never" indicator-position="none" ref="carousel">
              <el-carousel-item v-for="item in liveList" :key="item.id">
                <ul class="classItem" @mouseenter="upMore" @mouseleave="downMore">
                  <li
                      style="position: relative"
                      v-for="littleItem in item.item"
                      :key="littleItem.id"
                      @click="goCourseDetails(littleItem.id)"
                  >
                    <div class="imgs">
                      <img :src="littleItem.roomShowUrl" alt="" class="cla-p"/>
                    </div>
                    <p class="tag">{{ timestampToTime(littleItem.livesteramTime) }}</p>
                    <p>{{ littleItem.roomName }}</p>
                    <div class="classContent">
                      {{ littleItem.userName }}
                    </div>
                  </li>
                  <span v-if="moreFalse"
                        style="position: absolute;right: 0;top: 8px;cursor: pointer"
                        @click="goStudy">更多 &gt;</span>
                </ul>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <!-- 新课上线 End -->
      </div>
    </div>
    <!--    轮播图-->
    <!--        <div class="liveIng">
              <div class="index-content-box">
                <div class="liveIng-zt">正在直播</div>
                <div class="liveIng-box">
                  <div class="liveIng-box-left">
                    <img src="" alt="">
                  </div>
                  <div class="liveIng-box-right">
                    <img
                        class="top"
                        src="@/assets/images/jiantou.png"
                        alt="上一张"
                        @click="prevSlide"
                    >
                    &lt;!&ndash; 下箭头 - 点击切换到下一张 &ndash;&gt;
                    <img
                        class="bottom"
                        src="@/assets/images/jiantou.png"
                        alt="下一张"
                        @click="nextSlide"
                    >
                    <el-carousel ref="carousel" :interval="3000" direction="vertical" :autoplay="false">
                      <el-carousel-item v-for="item in 4" :key="item">
                        <div class="liveIng-box-right-swagger">
                          <div v-for="item in 3" :key="item">
                            <div>
                              {{ item }}
                            </div>
                          </div>
                        </div>
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                </div>
              </div>
            </div>-->
    <!--    热门课程-->
    <!--    <div class="hotClass">
          <div>
            &lt;!&ndash; 新课上线 &ndash;&gt;
            <div class="index-content-box">
              <div class="index-course">
                <div class="index-content-tit" :style="{ display: header }">
                  <h3 style="font-size: 24px;font-weight: bold">精彩回放</h3>
                  &lt;!&ndash;                            <span @click="goStudy">更多 &gt;</span>&ndash;&gt;
                </div>
                <div style="border-top: 1px solid #DDDDDD"></div>
                <ul class="classItem" @mouseenter="upMore" @mouseleave="downMore">
                  <li
                      style="position: relative"
                      v-for="item in classList"
                      :key="item.id"
                      @click="goCourseDetails(item.id)"
                  >
                    <div class="imgs">
                      <img :src="item.surfacePlotUrl" alt="" class="cla-p"/>
                    </div>
                    <p v-if="item.isPay === 3" class="tag">免费观看</p>
                    <p v-if="item.isPay === 2" class="tag">会员免费</p>
                    <p>{{ item.headline }}</p>
                    <div class="classContent">
                      {{ item.courseDescription }}
                    </div>
                    <div class="follow">
                      <i class="el-icon-view" style="color: #999999"></i>
                      已有<span style="color: #E97F37">{{ item.learnNumber }}</span>人学习
                    </div>
                  </li>
                  <span v-if="moreFalse"
                        style="position: absolute;right: 0;top: 8px;cursor: pointer"
                        @click="goStudy">更多 &gt;</span>
                </ul>
              </div>
            </div>

            &lt;!&ndash; 新课上线 End &ndash;&gt;
          </div>
        </div>-->
  </div>
</template>

<script>
import {hotEnterpriseMore} from "@/views/Findtalent/api";
import {getDocumentPicture} from "@/api/common";

export default {
  props: ["liveList"],
  data() {
    return {
      moreFalse: false,
      moreFalseInstitution: false,
      classList: [],
      bannerImage: '',
      inputcompany: "",
      total: 100,
      queryInfo: {
        pagenum: 1,
        pagesize: 12,
      },
      companylist: "",
      JQList: []
    };
  },
  mounted() {
    this.searchlist();
    getDocumentPicture(1, 36).then((res) => {
      if (res.code === 200) {
        this.bannerImage = res.data[0].pictureUrl
      }
    })

  },
  methods: {
    // 切换到上一张
    prevSlide() {
      this.$refs.carousel.prev();
    },
    // 切换到下一张
    nextSlide() {
      this.$refs.carousel.next();
    },
    timestampToTime(timestamp) {
      // 判断是10位还是13位时间戳（10位需要乘以1000）
      const date = new Date(
          timestamp.toString().length === 10
              ? timestamp * 1000
              : timestamp
      );
      const y = date.getFullYear();
      const MM = date.getMonth() + 1;
      const d = date.getDate();
      const h = date.getHours();
      const m = date.getMinutes();
      const s = date.getSeconds();
      // 补零操作
      const padZero = (num) => (num < 10 ? `0${num}` : num);
      return `${y}年${padZero(MM)}月${padZero(d)}日 ${padZero(h)}:${padZero(m)}:${padZero(s)}`;
    },
    upMore() {
      this.moreFalse = true
    },
    downMore() {
      this.moreFalse = false
    },
    goCourseDetails(id) {
      console.log(id);
      this.$router.push("/liveIndex?id=" + id);
    },
    goStudy() {
      this.$router.push("/liveMore");
    },
    hotmore() {
      let data = {
        current: this.queryInfo.pagenum,
        size: this.queryInfo.pagesize,
        title: this.inputcompany,
      };
      hotEnterpriseMore().then((res) => {
        if (res.code === 200) {
          res.data.forEach((item) => {
            if (item.institutionName.includes(this.inputcompany)) {
              item.institutionName = item.institutionName.replace(
                  this.inputcompany,
                  `<span style="color:#ff2832">${this.inputcompany}</span>`
              );
            }
          });
          this.companylist = res.data;
          this.total = res.data.total;
        }

      });

    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.searchlist();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage;
      this.searchlist();
    },
    searchlist() {
      this.hotmore();
    },
  },
};
</script>

<style lang='less' scoped>
* {
  margin: 0;
  padding: 0;
}


.liveIng-box {
  display: flex;
  align-content: center;
  //justify-content: space-between;
  justify-content: flex-start;
  height: 523px;


  .liveIng-box-left {
    background: aqua;
    width: 800px;
    border-radius: 10px;
  }

  .liveIng-box-right {
    position: relative;
    background: #f3f3f3;
    border-radius: 10px;
    width: 300px;
    padding: 35px 30px;

    .top {
      position: absolute;
      top: 5px;
      left: 50%;
      transform: rotate(90deg);
      width: 25px;
      height: 25px;
      cursor: pointer;
    }

    .bottom {
      cursor: pointer;
      position: absolute;
      bottom: 5px;
      left: 50%;
      transform: rotate(-90deg);
      height: 25px;
      width: 25px;
    }

    /deep/ .el-carousel__container {
      height: 233px !important;

      .liveIng-box-right-swagger {
        //height: 100%;
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: space-between;

        > div {
          background: black;
          height: 32%;
        }
      }
    }
  }
}

.index-content-box {
  //width: 1184px;
  margin: auto;
  margin-top: 20px !important;
  //padding: 20px;
  background-color: white;
  //border-radius: 20px;

  .index-course {
    position: relative;

    .jiantou-box {
      position: absolute;
      right: 0;
      top: 20px;

      img {
        width: 20px;
        height: 20px;
        cursor: pointer;
      }

      .right {
        margin-left: 10px;
        transform: rotate(-180deg);
      }
    }

    /deep/ .el-carousel {
      padding: 5px 0;
    }

    /deep/ .el-carousel__container {
      height: 250px;
    }
  }
}

.tag {
  position: absolute;
  left: 0;
  top: 0;
  height: 30px;
  width: 150px;
  //font-size: 0.75rem;
  font-size: 12px;
  color: white;
  text-align: center;
  line-height: 30px;
  //background-color: #e97f37;
  background-color: rgba(233, 127, 55, 0.8);
  border-radius: 0.5625rem 0 0.625rem 0;

}

.imgs {
  width: 100%;
  //height: 134px;
  height: 154px;
  overflow: hidden;
}

.cla-p {
  width: 100%;
  height: 100%;
  //object-fit: contain;
  transition: all 1s;
}

.classItem > li:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 5px 5px #dad8d8;
}

.classItem > li {
  transition: transform 0.5s ease;
}

.index-content-tit > h3 {
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 28px;
  border-left: #eb5139 7px solid;
  //border-radius: 4px;
  padding-left: 13px;
}

.index-content-tit {
  position: relative;
}

.index-content-tit > span {
  position: absolute;
  right: 5%;
  top: 15px;
  font-size: 16px;
  cursor: pointer;
  color: #666;
}

.classItem {
  //display: flex;
  flex-wrap: wrap;
  //justify-content: flex-start;
  //justify-content: space-evenly;
  padding: 5px 10px 0 10px; /* 上下左右内边距（左右20px） */
  position: relative;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(268px, 1fr)); /* 自适应列数 */
  gap: 15px; /* 固定间距 */
}

.classItem > li {
  background-color: #ffffff;
  border-radius: 9px;
  //width: 228px;
  overflow: hidden;
  cursor: pointer;
  padding-bottom: 10px;
  box-sizing: border-box;
  //margin: 0 0 0 10px;
  box-shadow: 0 0 5px 2px #e6e6e6;
}

.classItem > li:nth-child(1) {
  margin: 0;
}

.classItem > li > img {
  width: 100%;
}

.classItem > li > p:nth-child(3) {
  font-size: 14px;
  //width: 220px;
  height: 38px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
  margin: 6px 6px 5px;
}

.classContent {
  color: #999999;
  padding: 2px 10px;
  font-size: 12px;
  /* height: 32px;
   overflow: hidden; !* 超出容器高度的内容进行隐藏 *!
   display: -webkit-box;
   -webkit-line-clamp: 2; !* 设置行数为三行，兼容 WebKit 浏览器，如 Safari 和 Chrome *!
   -webkit-box-orient: vertical;*/
}


.follow {
  padding: 0 20px;
  //width: 200px;
  height: 20px;
  font-size: 12px;
  text-align: end;
  line-height: 20px;
  margin: 5px 0 0;
}


.information {
  padding: 2px 10px;
}

.information > span,
.information > em,
.information > div {
  font-size: 14px;
  color: gray;
}

.course ul {
  width: 890px;
}

.course ul > li {
  margin-bottom: 20px;
}

.metting-container .classItem > li {
  margin-right: 12px;
}

.hot-activities .classItem > li {
  margin-right: 12px;
}

.hot-activities .classItem > li:nth-child(3n) {
  margin-right: 0 !important;
}

.mainbody .index-content-tit {
  margin-left: 10px;
}

.mainbody .classItem {
  //padding: 0 10px;
  //display: flex;
  //justify-content: space-between;
}

.hot-activities .classItem {
  width: 100%;
}

.hotCompany {
  display: flex;
  justify-content: flex-start;
  //padding: 20px 0 10px 0;

  > h3 {
    margin: 20px 0 10px 0;
    font-size: 28px;
    border-left: #eb5139 4px solid;
    border-radius: 4px;
    padding-left: 13px;
  }
}


.enterprise {
  background: #F5F5F5;
  position: relative;
  //padding-bottom: 20px;

  .gradient {
    width: 100%;
    height: 400px;
    position: absolute;
    top: 100px;
    left: 0;
  }

  .image {
    //margin-top: 20px;
    position: relative;
    width: 100%;
    height: 300px;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .headsearch {
    position: absolute;
    margin-top: 350px;
    margin-left: 480px;

    .search {
      margin: 0 auto;
      width: 900px;
      position: relative;
      height: 90px;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 12px;

      .searchinput {
        border: 1px solid #eb5139;
        border-radius: 12px;
        overflow: hidden;
      }
    }

    .search /deep/ .searchinput {
      width: 100%;
      height: 50px;
    }

    .searchinput /deep/ .el-input__inner {
      border: none;
      height: 100%;
    }

    .searchinput /deep/ .el-input-group__append {
      border: none;
      width: 150px;
      background: #eb5139;
      color: #fff;
      text-align: center;
      border-radius: 0;
      font-size: 18px;

      .el-input-group__append button.el-button {
        width: 100%;
        height: 100%;
      }
    }
  }

  .company-list {
    position: relative;
    width: 1184px;
    overflow: hidden;
    margin: 20px auto 0;
    background-color: white;
    padding: 20px;
    border-radius: 20px;

    .company {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding-left: 20px;
      padding-top: 35px;
      position: relative;

      .company-independence {
        //height: 270px;
        padding-bottom: 20px;
        width: 268px;
        border-radius: 12px;
        overflow: hidden;
        margin: 0 23px 23px 0;
        transition: transform 0.3s ease;
        border: 1px solid #eeeeee;

        .sub-li-top {
          padding: 30px 20px 10px 20px;
          //background: #fff;
          display: flex;
          background: linear-gradient(to bottom, #F2FAFA, white);

          img {
            width: 50px;
            height: 50px;
            margin: 0 10px 0 0;
            border-radius: 50%;
            background-color: white;
            object-fit: scale-down;
          }

          .text {
            //flex: 1;
            margin: 0;
            width: 148px;

            .title {
              width: 100%;
              font-size: 16px;
              margin-bottom: 9px;
              color: #222;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              //font-weight: 600;
            }

            .conpany-text {
              display: flex;

              li {
                display: inline-block;
                color: #666;
                padding: 0 8px;
                background: #f8f8f8;
                font-size: 13px;
                border-radius: 4px;
                max-width: 66px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 22px;
                margin: 0 5px 0 0;
              }
            }

            .hotrecruitment {
              width: 44%;
              text-align: center;
              color: #999999;
              margin: 0;
            }
          }
        }

        .sub-li-bottom {
          width: 100%;
          height: 48px;
          line-height: 48px;
          font-size: 14px;
          color: #666;
          //background: linear-gradient(90deg, #f5fcfc 0, #fcfbfa 100%);
          padding: 0 22px;
          box-sizing: border-box;
          display: flex;
          margin-top: 20px;

          .centerhotrecruitment {
            width: 50%;
            margin: 0;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;

            > div {
              //height: 10px;
              line-height: 0;
              width: 100%;
            }

            > div:nth-child(1) {
              margin-bottom: 10px;
            }
          }

          .hotrecruitment {
            width: 50%;
            margin: 0;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;

            > div {
              line-height: 0;
              width: 100%;
            }

            > div:nth-child(1) {
              margin-bottom: 10px;
            }
          }

          .line {
            height: 25px;
            width: 1px;
            font-size: 14px;
            color: #666;
            background: #ccc;
            position: relative;
            right: 10px;
            top: 18px;
            margin: 0 -10px 0 10px;
          }

          .salary {
            margin: 0;
          }
        }

        .button {
          text-align: center;
          margin: 34px auto auto;

          > button {
            cursor: pointer;
            margin: auto;
            width: 160px;
            height: 34px;
            border-radius: 30px;
            background-color: white;
            border: 1px solid #FF3F29;
            color: #FF3F29;
          }

          > button:hover {
            color: white;
            background-color: #FF3F29;
          }
        }
      }

      .company-independence:hover {
        transform: translateY(-5px);
        box-shadow: 0 0 10px 5px #eee7e7;
      }

    }
  }

  .page {
    width: 412px;
    margin: 30px auto 31px;
  }
}
</style>
